import { getContractWithABI, getTokenDefinition, type ValidChainId, } from "@bracket/chainography";
import { getViemClients, } from "@bracket/contractor-next";
import type { Config, } from "@wagmi/core";


export declare type GetClaimedAmountProps = {
	address: string;
	attempt?: number;
	config?: Config;
	chainId?: ValidChainId;
};

export const getClaimedAmount = async ({
	address,
	config,
	chainId = 1,
}: GetClaimedAmountProps): Promise<bigint> => {

	try {

		const [client, _] = await getViemClients({ config, chainId, });
		const [contract, abi] = getContractWithABI("BracketEscrow");
		const brkt = getTokenDefinition({ symbol: "BRKTETH", chainId, });
		const result = await client.readContract({
			address: contract,
			abi,
			functionName: "getClaimedAmount",
			args: [
				address,
				brkt.address,
			],
		});

		return result as bigint;

	}
	catch( err ) {

		console.log("@bracket/contractor::getClaimedAmount error:", err);
		throw new Error(`@bracket/contractor/bracket-escrow::GetClaimedAmount has failed ${err.message}`);
	}

}

